@if (!isMobile) {
    <div class='spinner-container' [hidden]="!technicianTicketsSpinnerActive">
      <div class="spinner"></div>
    </div>
    <div class="ticket-view" [hidden]="technicianTicketsSpinnerActive" [dir]="currentLang ? (currentLang == 'iw' ? 'rtl' : 'ltr') : 'auto'">
      <div class="tab-width">
        <div class='search-input-container' rtlDiv>
          <div class="search-container">
            <img class='search-input-img' src="assets/images/sidemenu/table_search_icon.png" alt="" />
            <input id="technicianFilter" class='search-input' type="text" (input)="applyTechnicianFilter($event.target['value'])" placeholder="{{'OTHER.SEARCH' | translate }}" name="">
          </div>
          <div class='table-export-container' rtlDiv>
            <div class='table-export-btns-wrapper' (click)="exportToCsv()" rtlDiv>
              <img class='table-export-img excel' src="assets/images/dashboard/Excel.svg" alt="" />
              <div class='table-export-title' rtlDiv>{{ 'OTHER.EXCEL' | translate }}</div>
            </div>
            <div class="manage-bins-btn-container" (click)="openAddTicket()" rtlDiv>
              <a class="manage-bins-btn" rtlDiv>
                <span>
                  <img class="arow_manage" src="assets/images/dashboard/Plus.svg" rtlDiv/>
                </span>
                <span class="btn-text">{{ 'TICKET_MANAGEMENT.ADD_EVENT' | translate }}</span>
              </a>
            </div>              
          </div>
        </div>
        <app-filter-bar [page]="'technicianTicketManagement'" [arrayToFilter]="technicianTickets$" (filterStatus)="filterStatusHandler($event)"></app-filter-bar>
        <table class="table" mat-table [dataSource]="technicianTicketsDataSource" matSort
          matSortDisableClear (matSortChange)="sortTechnicianTicketsData($event)">
          <ng-container matColumnDef="ticket_type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="ticket_type" class="th-title">
            {{ 'TICKET_MANAGEMENT.EVENT_TYPE' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value">
              @if (currentLang != 'iw') {
                <span rtlDiv> {{element ? element.ticket_type : ''}}</span>
              }
              @if (currentLang == 'iw') {
                <span rtlDiv> {{element ? element.ticket_type_hebrew : ''}}</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="ticket_id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="ticket_id" class="th-title padding-value">
            {{ 'TICKET_MANAGEMENT.EVENT_ID' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value padding-value">
              <span> {{element ? element.ticket_id : ''}}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="ticket_status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="status" class="th-title padding-value">
            {{ 'TICKET_MANAGEMENT.STATUS' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value padding-value">
              <span [ngClass]="{'pc-opened-event' : element.status == 1, 'pc-closed-event' : element.status == 4, 'pc-onhold-event' : element.status == 3}">{{element ? element.status_txt : ''}}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="event_cause">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="ticket_event_cause_id" class="th-title padding-value">
            {{ 'TICKET_MANAGEMENT.EVENT_CAUSE' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value padding-value">
              @if (currentLang != 'iw') {
                <span rtlDiv> {{element ? element.eventCauseEn : ''}}</span>
              }
              @if (currentLang == 'iw') {
                <span rtlDiv> {{element ? element.eventCauseHe : ''}}</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="priority">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="priority_id" class="th-title padding-value">
            {{ 'TICKET_MANAGEMENT.PRIORITY' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value padding-value">
              <div class="dflex-center" rtlDiv>
                <span [ngClass]="{'low-priority-dot':element.priority_id == 1,'medium-priority-dot':element.priority_id == 2,'high-priority-dot':element.priority_id == 3}"></span>
                @if (currentLang != 'iw') {
                  <span> {{element ? element.priorityEn : ''}}</span>
                }
                @if (currentLang == 'iw') {
                  <span> {{element ? element.priorityHe : ''}}</span>
                }
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="site_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="site_name" class="th-title padding-value">
            {{ 'TICKET_MANAGEMENT.SITE' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value padding-value">
              <span rtlDiv> {{element ? element.site_name : ''}}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="bin_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="bin_name" class="th-title padding-value">
            {{ 'TICKET_MANAGEMENT.BIN_NAME' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value padding-value">
              @if (element.bin_id == 0 || element.bin_id == '') {
                <span> {{element ? element.bin_name : ''}}</span>
              }
              @if (element.bin_id != 0 && element.bin_id != '') {
                <span class="td-value clickable" (click)="openElementBinInfo(element)" title="{{element ? element.bin_name : ''}}">{{element ? element.bin_name : ''}}</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="bin_address">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="bin_address" class="th-title padding-value">
            {{ 'TICKET_MANAGEMENT.BIN_ADDRESS' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value padding-value">
              <span rtlDiv> {{element ? element.bin_address : ''}}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="comment">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="comment" class="th-title padding-value">
            {{ 'TICKET_MANAGEMENT.DESCRIPTION' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value padding-value">
              <span class="cut-txt" [title]="element ? element.comment : ''" rtlDiv> {{element ? element.comment : ''}}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="assignee">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="assignee" class="th-title padding-value">
            {{ 'TICKET_MANAGEMENT.ASSIGNEE' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value padding-value">                      
              <span rtlDiv> {{element ? (element.assigned_user_first_name == null || element.assigned_user_last_name == null ? '' : element.assignee) : ''}}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="reporter">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="reporter" class="th-title padding-value">
            {{ 'TICKET_MANAGEMENT.REPORTER' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value padding-value">
              <span rtlDiv> {{element ? (element.first_name == null || element.last_name == null ? '' : element.reporter) : ''}}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="created">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="created_DateTime_value" class="th-title padding-value">
            {{ 'TICKET_MANAGEMENT.CREATED' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value padding-value">
              <span rtlDiv>
                {{currentLang == 'iw' && element ? element.created_he : element.created}}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="arrival_date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="expected_arrival_date" class="th-title padding-value">
            {{ 'TICKET_MANAGEMENT.EXPECTED_ARRIVAL_DATE' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value padding-value">
              <span rtlDiv>
                {{currentLang == 'iw' && element ? element.expected_arrival_date_he : element.expected_arrival_date}}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="closed">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="closed_DateTime_value" class="th-title padding-value">
            {{ 'TICKET_MANAGEMENT.CLOSED' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value padding-value">
              <span>
                {{currentLang == 'iw' && element ? element.closed_he : element.closed}}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="removedReason">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="removedReason" class="th-title padding-value">
            {{ 'TICKET_MANAGEMENT.REMOVED_REASON' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="td-value padding-value">
              @if (currentLang != 'iw') {
                <span> {{element ? element.reasonOfReplacementEn : ''}}</span>
              }
              @if (currentLang == 'iw') {
                <span> {{element ? element.reasonOfReplacementHe : ''}}</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="manage">
            <th mat-header-cell *matHeaderCellDef disabled="true" mat-sort-header="manage"> </th>
            <td mat-cell *matCellDef="let element" class="manage-bins">
              <div class="menu-Cmp" rtlDiv>
                <div class="dropdown-toggle" data-bs-toggle="dropdown">
                  <img alt="" src="../../../assets/images/dashboard/threedots.svg">
                </div>
                <div class="dropdown-menu list-items" rtlDiv>
                  <div class="menuItem" (click)="viewAction(element)">
                    <span class="item-txt">{{ 'TICKET_MANAGEMENT.VIEW' | translate }}</span>
                  </div>                    
                  @if (deleteOwnEvent(element)) {
                    <div class="menuItem" (click)="deleteAction(element,element.status)">
                      <span class="item-txt">{{ 'TICKET_MANAGEMENT.DELETE' | translate }}</span>
                    </div>
                  }
                  @if (((user_role_id == 5 || user_role_id == 6) && (element.status == 1 || element.status == 3)) ||
                  (((user_role_id == 2 || user_role_id == 4) && element.ticket_event_cause_id == 15) && (element.status == 1 || element.status == 3)) ||
                  (((user_role_id == 2 || user_role_id == 4) && element.status == 3) && (element.status == 1 || element.status == 3))){
                    <div class="menuItem" (click)="resolveAction(element)">
                      <span class="item-txt">{{ 'TICKET_MANAGEMENT.CLOSE' | translate }}</span>
                    </div>
                  }
                  @if (element.status == 1) {
                    <div class="menuItem" (click)="editAction(element)">
                      <span class="item-txt">{{ 'TICKET_MANAGEMENT.EDIT' | translate }}</span>
                    </div>
                  }
                  @if (element.status == 4) {
                    <div class="menuItem" (click)="reopenAction(element)">
                      <span class="item-txt">{{ 'TICKET_MANAGEMENT.REOPEN' | translate }}</span>
                    </div>
                  }
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedTechnicianTicketsColumns"></tr>
          <tr class="ticket-row" mat-row *matRowDef="let row; columns: displayedTechnicianTicketsColumns;" [ngClass]="{'highlight-row': row.ticket_id == markerSelected['ticket_id']}"></tr>
        </table>
        @if (technicianTicketsTableLength > 0) {
          <div>
            <app-pagination [chosenBins]="filteredTechnicianTicketsData" (pageChange)='onTechnicianPageChange($event)' [filesPerPage]="10"></app-pagination>
          </div>
        }
      </div>
      <app-technician-ticket-management-map (markerSelected)="handleMarkerSelected($event)" (markerDeselected)="handleMarkerDeselected()" [technicianTicketsArray]="filteredTechnicianTicketsData"></app-technician-ticket-management-map>
    </div>
  }
  @if (isMobile) {
    <div class="mobile-group-tabs">
      <div class="card mobile-card">
        <div class="card-body">
          <div class="mobile-search-excel">
            <div class='mobile-search-container'>
              <img class='mobile-search-img' src="assets/images/sidemenu/table_search_icon.png" alt="" rtlDiv />
              <input id="mobile-cancellation-filter" class='mobile-input' type="text" (input)="applyTechnicianFilter($event.target['value'])" placeholder="{{'OTHER.SEARCH' | translate}}" rtlDiv>
            </div>
            <div class="display-icons">
              @if (mapTechnicianExpanded) {
                <div class="padding-img">
                  <img (click)="expandTechnicianTicketsMap()" src="assets/images/sidemenu/expand-map.svg" alt="" rtlDiv />
                </div>
              }
              @if (!mapTechnicianExpanded) {
                <div class="padding-img">
                  <img (click)="expandTechnicianTicketsMap()" src="assets/images/sidemenu/not-expand-map.svg" alt="" rtlDiv />
                </div>
              }
              <div class="padding-img dropdown">
                <div class="dropdown-toggle" data-bs-toggle="dropdown">
                  <img src="assets/images/sidemenu/menu-dots.svg" alt="" rtlDiv />
                </div>
                <div class="dropdown-menu mobile-dropdown-list" rtlDiv>
                  <div class="mobile-menuItem">
                    <div class="menu-row" (click)="exportToCsv()" rtlDiv>
                      <img src="assets/images/sidemenu/mobile-excel.svg" alt="" rtlDiv />
                      <span class="mobile-item-txt">{{ 'OTHER.EXCEL' | translate }}</span>
                    </div>
                    <div class="menu-row" (click)="openAddTicket()" rtlDiv>
                      <img src="assets/images/sidemenu/mobile-add.svg" alt="" rtlDiv />
                      <span class="mobile-item-txt">{{ 'TICKET_MANAGEMENT.ADD_EVENT' | translate }}</span>
                    </div>                  
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="full-width" [hidden]="!technicianTicketsSpinnerActive">
            <div class="spinner-border mobile-spinner">
              <div class="spinner"></div>
            </div>
          </div>
          @if (!technicianTicketsSpinnerActive && mapTechnicianExpanded) {
            <div class="mobile-map-frame">
              <app-technician-ticket-management-map (markerSelected)="handleMarkerSelected($event)" (markerDeselected)="handleMarkerDeselected()" [technicianTicketsArray]="filteredTechnicianTicketsData"></app-technician-ticket-management-map>
            </div>
          }
          <div id="cancellationTable" [hidden]="technicianTicketsSpinnerActive">
            <app-filter-bar [page]="'technicianTicketManagement'" [arrayToFilter]="technicianTickets$" (filterStatus)="filterStatusHandler($event)"></app-filter-bar>
            <table class="mobile-table" mat-table [dataSource]="technicianTicketsDataSource" matSort
              multiTemplateDataRows matSortDisableClear (matSortChange)="sortTechnicianTicketsData($event)">
              <ng-container matColumnDef="ticket_status">
                <th [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketStatusChecked" mat-header-cell *matHeaderCellDef mat-sort-header="status" class="mobile-th-title">
                {{ 'TICKET_MANAGEMENT.STATUS' | translate }} </th>
                <td [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketStatusChecked" class="mobile-td-title" mat-cell *matCellDef="let element">
                  <span [ngClass]="{'opened-event' : element.status == 1, 'closed-event' : element.status != 1}">{{element ? element.status_txt : ''}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="event_cause">
                <th [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketCauseChecked" mat-header-cell *matHeaderCellDef mat-sort-header="ticket_event_cause_id" class="mobile-th-title">
                {{ 'TICKET_MANAGEMENT.EVENT_CAUSE' | translate }} </th>
                <td [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketCauseChecked" class="mobile-td-title" mat-cell *matCellDef="let element">
                  @if (currentLang != 'iw') {
                    <span class="mobile-td"> {{element ? element.eventCauseEn : ''}}</span>
                  }
                  @if (currentLang == 'iw') {
                    <span class="mobile-td"> {{element ? element.eventCauseHe : ''}}</span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="arrival_date">
                <th [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isArrivalDateChecked" mat-header-cell *matHeaderCellDef mat-sort-header="expected_arrival_date" class="mobile-th-title">
                {{ 'TICKET_MANAGEMENT.EXPECTED_ARRIVAL_DATE' | translate }} </th>
                <td [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isArrivalDateChecked" class="mobile-td-title" mat-cell *matCellDef="let element">
                  <span class="mobile-td">
                    {{currentLang == 'iw' && element ? element.expected_arrival_date_he : element.expected_arrival_date}}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="ticket_type">
                <th [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketTypeChecked" mat-header-cell *matHeaderCellDef mat-sort-header="ticket_type" class="mobile-th-title">{{ 'TICKET_MANAGEMENT.EVENT_TYPE' | translate }}</th>
                <td [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketTypeChecked" mat-cell *matCellDef="let element" class="mobile-td-title">
                  <span class="mobile-td"> 
                    @if (currentLang != 'iw') {
                      <span rtlDiv> {{element ? element.ticket_type : ''}}</span>
                    }
                    @if (currentLang == 'iw') {
                      <span rtlDiv> {{element ? element.ticket_type_hebrew : ''}}</span>
                    }
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="ticket_id">
                <th [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketIdChecked" mat-header-cell *matHeaderCellDef mat-sort-header="ticket_id" class="mobile-th-title">{{ 'TICKET_MANAGEMENT.EVENT_ID' | translate }}</th>
                <td [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketIdChecked" mat-cell *matCellDef="let element" class="mobile-td-title">
                  <span class="mobile-td"> {{element ? element.ticket_id : ''}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="priority">
                <th [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketPriorityChecked" mat-header-cell *matHeaderCellDef mat-sort-header="priority_id" class="mobile-th-title">{{ 'TICKET_MANAGEMENT.PRIORITY' | translate }} </th>
                <td [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketPriorityChecked" mat-cell *matCellDef="let element" class="mobile-td-title">
                  <div class="dflex-center" rtlDiv>
                    <span [ngClass]="{'low-priority-dot':element.priority_id == 1,'medium-priority-dot':element.priority_id == 2,'high-priority-dot':element.priority_id == 3}"></span>
                    @if (currentLang != 'iw') {
                      <span class="mobile-td"> {{ element ? element.priorityEn : ''}}</span>
                    }
                    @if (currentLang == 'iw') {
                      <span class="mobile-td"> {{element ? element.priorityHe : ''}}</span>
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="site_name">
                <th [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketSiteChecked" mat-header-cell *matHeaderCellDef mat-sort-header="site_name" class="mobile-th-title">
                {{ 'TICKET_MANAGEMENT.SITE' | translate }} </th>
                <td [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketSiteChecked" mat-cell *matCellDef="let element" class="mobile-td-title">
                  <span class="mobile-td" rtlDiv> {{element ? element.site_name : ''}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="bin_name">
                <th [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isBinNameChecked" mat-header-cell *matHeaderCellDef mat-sort-header="bin_name" class="mobile-th-title">
                {{ 'TICKET_MANAGEMENT.BIN_NAME' | translate }} </th>
                <td [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isBinNameChecked" mat-cell *matCellDef="let element" class="mobile-td-title">
                  @if (element.bin_id == 0 || element.bin_id == '') {
                    <span class="mobile-td"> {{element ? element.bin_name : ''}}</span>
                  }
                  @if (element.bin_id != 0 && element.bin_id != '') {
                    <a [routerLink]="['/binLiveInfoPage']" [queryParams]="{pageName:'ticketManagement',binId:element.bin_id}" title="{{element ? element.bin_name : ''}}" class="mobile-td"> {{element ? element.bin_name : ''}}</a>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="bin_address">
                <th [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketAddressChecked" mat-header-cell *matHeaderCellDef mat-sort-header="bin_address" class="mobile-th-title">
                {{ 'TICKET_MANAGEMENT.BIN_ADDRESS' | translate }} </th>
                <td [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketAddressChecked" mat-cell *matCellDef="let element" class="mobile-td-title">
                  <span class="mobile-td cut-txt" rtlDiv> {{element ? element.bin_address : ''}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="comment">
                <th [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isDescChecked" mat-header-cell *matHeaderCellDef mat-sort-header="comment" class="mobile-th-title">
                {{ 'TICKET_MANAGEMENT.DESCRIPTION' | translate }} </th>
                <td [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isDescChecked" mat-cell *matCellDef="let element" class="mobile-td-title">
                  <span class="mobile-td cut-txt" rtlDiv> {{element ? element.comment : ''}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="assignee">
                <th [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isAssigneeChecked" mat-header-cell *matHeaderCellDef mat-sort-header="assignee" class="mobile-th-title">
                {{ 'TICKET_MANAGEMENT.ASSIGNEE' | translate }} </th>
                <td [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isAssigneeChecked" mat-cell *matCellDef="let element" class="mobile-td-title">
                  <span class="mobile-td" rtlDiv> {{element ? (element.assigned_user_first_name == null || element.assigned_user_last_name == null ? '' : element.assignee) : ''}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="reporter">
                <th [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isReporterChecked" mat-header-cell *matHeaderCellDef mat-sort-header="reporter" class="mobile-th-title">
                {{ 'TICKET_MANAGEMENT.REPORTER' | translate }} </th>
                <td [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isReporterChecked" mat-cell *matCellDef="let element" class="mobile-td-title">
                  <span class="mobile-td" rtlDiv> {{element ? element.reporter : ''}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="created">
                <th [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketCreatedChecked" mat-header-cell *matHeaderCellDef mat-sort-header="created_DateTime_value" class="mobile-th-title">
                {{ 'TICKET_MANAGEMENT.CREATED' | translate }} </th>
                <td [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketCreatedChecked" mat-cell *matCellDef="let element" class="mobile-td-title">
                  <span class="mobile-td" rtlDiv>
                    {{currentLang == 'iw' && element ? element.created_he : element.created}}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="closed">
                <th [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketClosedChecked" mat-header-cell *matHeaderCellDef mat-sort-header="closed_DateTime_value" class="mobile-th-title">
                {{ 'TICKET_MANAGEMENT.CLOSED' | translate }} </th>
                <td [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isTicketClosedChecked" mat-cell *matCellDef="let element" class="mobile-td-title">
                  <span class="mobile-td">
                    {{currentLang == 'iw' && element ? element.closed_he : element.closed}}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="removedReason">
                <th [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isRemovedReasonChecked" mat-header-cell *matHeaderCellDef mat-sort-header="removedReason" class="mobile-th-title">
                {{ 'TICKET_MANAGEMENT.REMOVED_REASON' | translate }} </th>
                <td [hidden]="!ticketManagementTechnicianTicketsSelectedValues.isRemovedReasonChecked" mat-cell *matCellDef="let element" class="mobile-td-title">
                  @if (currentLang != 'iw') {
                    <span class="mobile-td"> {{element ? element.reasonOfReplacementEn : ''}}</span>
                  }
                  @if (currentLang == 'iw') {
                    <span class="mobile-td"> {{element ? element.reasonOfReplacementHe : ''}}</span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="arrowDown">
                <th class="mobile-th-title" rtlDiv mat-header-cell *matHeaderCellDef>
                  <img (click)="openTechnicianColumnManaging()" rtlDiv src="assets/images/dashboard/addCol.svg" alt=""/>       
                </th>
                <td class=" " mat-cell *matCellDef="let element">
                  <div rtlDiv class="mobile-status-value" (click)="handleExpandedElm(element)">
                    @if (expandedElementTable['ticket_id'] != element['ticket_id']) {
                      <img rtlDiv class="mobile-status-img" src="assets/images/dashboard/arrow_closed.svg" alt=""/>
                    }
                    @if (expandedElementTable['ticket_id'] == element['ticket_id']) {
                      <img rtlDiv class="mobile-status-img" src="assets/images/dashboard/arrow_opened.svg" alt=""/>
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="expandedDetail">
                <td class="mobile-details-td" mat-cell *matCellDef="let element" [attr.colspan]="technicianTicketsColumnsToDisplay.length" rtlDiv>
                  <div class="mobile-row-details mobile-element-detail" [class.expanded]="element['ticket_id'] == expandedElementTable['ticket_id']">
                    <div class="mobile-element-diagram" rtlDiv>
                      <div class="mobile-item-details">
                        @if(!ticketManagementTechnicianTicketsSelectedValues.isTicketTypeChecked){
                          <div class="dFlex">
                            <div class="mobile-details-title">{{ 'TICKET_MANAGEMENT.EVENT_TYPE' | translate }}</div>
                            <div class="mobile-details-value"> {{currentLang == 'iw' && element ? element.ticket_type_hebrew : element.ticket_type}} </div>
                          </div>
                        }
                        @if(!ticketManagementTechnicianTicketsSelectedValues.isTicketIdChecked){
                          <div class="dFlex">
                            <div class="mobile-details-title">{{ 'TICKET_MANAGEMENT.EVENT_ID' | translate }}</div>
                            <div class="mobile-details-value"> {{element ? element.ticket_id : ''}} </div>
                          </div>
                        }
                        @if(!ticketManagementTechnicianTicketsSelectedValues.isTicketCauseChecked){
                          <div class="dFlex">
                            <div class="mobile-details-title">{{ 'TICKET_MANAGEMENT.EVENT_CAUSE' | translate }}</div>
                            <div class="mobile-details-value"> {{currentLang == 'iw' && element ? element.eventCauseHe : element.eventCauseEn}} </div>
                          </div>
                        }
                        @if(!ticketManagementTechnicianTicketsSelectedValues.isTicketPriorityChecked){
                          <div class="dFlex">
                            <div class="mobile-details-title">{{ 'TICKET_MANAGEMENT.PRIORITY' | translate }}</div>
                            <div class="mobile-details-value">
                              <span [ngClass]="{'low-priority-dot':element.priority_id == 1,'medium-priority-dot':element.priority_id == 2,'high-priority-dot':element.priority_id == 3}"></span>
                              @if (currentLang != 'iw') {
                                <span> {{ element ? element.priorityEn : ''}}</span>
                              }
                              @if (currentLang == 'iw') {
                                <span> {{element ? element.priorityHe : ''}}</span>
                              }
                            </div>
                          </div>                        
                        }
                        @if(!ticketManagementTechnicianTicketsSelectedValues.isTicketSiteChecked){
                          <div class="dFlex">
                            <div class="mobile-details-title">{{ 'TICKET_MANAGEMENT.SITE' | translate }}</div>
                            <div class="mobile-details-value"> {{element ? element.site_name : ''}} </div>
                          </div>
                        }
                        @if(!ticketManagementTechnicianTicketsSelectedValues.isBinNameChecked){
                          <div class="dFlex">
                            <div class="mobile-details-title">{{ 'TICKET_MANAGEMENT.BIN_NAME' | translate }}</div>
                            <div class="mobile-details-value">
                              @if (element.bin_id == 0 || element.bin_id == '') {
                                <span> {{element ? element.bin_name : ''}}</span>
                              }
                              @if (element.bin_id != 0 && element.bin_id != '') {
                                <a class="binName" [routerLink]="['/binLiveInfoPage']" [queryParams]="{pageName:'ticketManagement',binId:element.bin_id}" title="{{element ? element.bin_name : ''}}"> {{element ? element.bin_name : ''}}</a>
                              }
                            </div>
                          </div>
                        }
                        @if(!ticketManagementTechnicianTicketsSelectedValues.isTicketAddressChecked){
                          <div class="dFlex">
                            <div class="mobile-details-title">{{ 'TICKET_MANAGEMENT.BIN_ADDRESS' | translate }}</div>
                            <div class="mobile-details-value"> {{element ? element.bin_address : ''}} </div>
                          </div>
                        }
                        @if(!ticketManagementTechnicianTicketsSelectedValues.isDescChecked){
                          <div class="dFlex">
                            <div class="mobile-details-title">{{'TICKET_MANAGEMENT.DESCRIPTION' | translate}}</div>
                            <div [ngClass]="{'mobile-details-value-rtl':currentLang != 'iw','mobile-details-value-ltr':currentLang == 'iw'}"> {{element ? element.comment : ''}} </div>
                          </div>
                        }
                        @if(!ticketManagementTechnicianTicketsSelectedValues.isAssigneeChecked){
                          <div class="dFlex">
                            <div class="mobile-details-title">{{'TICKET_MANAGEMENT.ASSIGNEE' | translate}}</div>
                            <div class="mobile-details-value"> {{element ? (element.assigned_user_first_name == null || element.assigned_user_last_name == null ? '' : element.assignee) : ''}} </div>
                          </div>
                        }
                        @if(!ticketManagementTechnicianTicketsSelectedValues.isReporterChecked){
                          <div class="dFlex">
                            <div class="mobile-details-title">{{'TICKET_MANAGEMENT.REPORTER' | translate}}</div>
                            <div class="mobile-details-value"> {{element ? (element.first_name == null || element.last_name == null ? '' : element.reporter) : ''}} </div>
                          </div>
                        }
                        @if(!ticketManagementTechnicianTicketsSelectedValues.isTicketCreatedChecked){
                          <div class="dFlex">
                            <div class="mobile-details-title">{{'TICKET_MANAGEMENT.CREATED' | translate}}</div>
                            <div class="mobile-details-value"> {{currentLang == 'iw' && element ? element.created_he : element.created}} </div>
                          </div>
                        }
                        @if(!ticketManagementTechnicianTicketsSelectedValues.isArrivalDateChecked){
                          <div class="dFlex">
                            <div class="mobile-details-title">{{'TICKET_MANAGEMENT.EXPECTED_ARRIVAL_DATE' | translate}}</div>
                            <div class="mobile-details-value"> {{currentLang == 'iw' && element ? element.expected_arrival_date_he : element.expected_arrival_date}} </div>
                          </div>
                        }
                        @if(!ticketManagementTechnicianTicketsSelectedValues.isTicketClosedChecked){
                          <div class="dFlex">
                            <div class="mobile-details-title">{{'TICKET_MANAGEMENT.CLOSED' | translate}}</div>
                            <div class="mobile-details-value">{{currentLang == 'iw' && element ? element.closed_he : element.closed}}</div>
                          </div>
                        }
                        @if(!ticketManagementTechnicianTicketsSelectedValues.isRemovedReasonChecked){
                          <div class="dFlex">
                            <div class="mobile-details-title">{{'TICKET_MANAGEMENT.REMOVED_REASON' | translate}}</div>
                            <div class="mobile-details-value">{{currentLang == 'iw' && element ? element.reasonOfReplacementHe : element.reasonOfReplacementEn}}</div>
                          </div>
                        }
                        @if (element.status != 1) {
                          <div class="dFlex">
                            <div class="mobile-details-title">{{'TICKET_MANAGEMENT.DESCRIPTION' | translate}}</div>
                            <div [ngClass]="{'mobile-details-value-rtl':currentLang != 'iw','mobile-details-value-ltr':currentLang == 'iw'}"> {{element ? element.resolvedDescription : ''}} </div>
                          </div>
                          @if(element.ticket_event_type_id == 4){
                            <div class="dFlex">
                              <div class="mobile-details-title">{{'TICKET_MANAGEMENT.UNIT_IS_CANCELED' | translate}}</div>
                              <div class="mobile-details-value">
                                @if (element.is_removed_from_bin == 1) {
                                  <span>{{ 'OTHER.YES' | translate }}</span>
                                }
                                @if (element.is_removed_from_bin == 0) {
                                  <span>{{ 'OTHER.NO' | translate }}</span>
                                }
                              </div>
                            </div>
                            <div class="dFlex">
                              <div class="mobile-details-title">{{'TICKET_MANAGEMENT.UNIT_REMOVED_FROM_SITE' | translate}}</div>
                              <div class="mobile-details-value">
                                @if (element.is_removed_from_site == 1) {
                                  <span>{{ 'OTHER.YES' | translate }}</span>
                                }
                                @if (element.is_removed_from_site == 0) {
                                  <span>{{ 'OTHER.NO' | translate }}</span>
                                }
                              </div>
                            </div>
                          }
                        }
                      </div>
                      @if(element.status == 1 || deleteOwnEvent(element)){
                        <div class="dFlex padding-border">
                          <div class="mobile-details-value title-width">{{'SITE_MANAGMENT.ACTIONS' | translate}}:</div>
                          <div class="actions-container" rtlDiv>
                            @if (element.status == 1) {
                              <div rtlDiv class="action-frame" (click)="editAction(element)">
                                <img src="assets/images/sidemenu/edit-pen.svg" alt=""/>
                                <span class="action-txt">{{ 'TICKET_MANAGEMENT.EDIT' | translate }}</span>
                              </div>
                            }
                            @if (((user_role_id == 5 || user_role_id == 6) && (element.status == 1 || element.status == 3)) ||
                            (((user_role_id == 2 || user_role_id == 4) && element.ticket_event_cause_id == 15) && (element.status == 1 || element.status == 3)) ||
                            (((user_role_id == 2 || user_role_id == 4) && element.status == 3) && (element.status == 1 || element.status == 3))){
                              <div rtlDiv class="action-frame" (click)="resolveAction(element)">
                                <img src="assets/images/sidemenu/correct-symbol.svg" alt=""/>
                                <span class="action-txt">{{ 'TICKET_MANAGEMENT.CLOSE' | translate }}</span>
                              </div> 
                            }                         
                            @if (deleteOwnEvent(element)) {
                              <div rtlDiv class="delete-action-frame" (click)="deleteAction(element,element.status)">
                                <img src="assets/images/sidemenu/red-bin.svg" alt=""/>
                                <span class="action-txt">{{ 'TICKET_MANAGEMENT.DELETE' | translate }}</span>
                              </div>
                            }
                          </div>
                        </div>
                      }      
                    </div>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="technicianTicketsColumnsToDisplay"></tr>
              <tr mat-row *matRowDef="let element; columns: technicianTicketsColumnsToDisplay;"
                (click)="expandedElement = expandedElement === element ? null : element">
              </tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="mobile-detail-row"></tr>
            </table>
            @if (technicianTicketsTableLength > 0) {
              <div>
                <app-pagination [chosenBins]="filteredTechnicianTicketsData" (pageChange)='onTechnicianPageChange($event)' [filesPerPage]="10"></app-pagination>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
  